<template>
  <div class="
      bg-primary
      relative
      
      h-16
      min-w-[110px]
      px-4
      flex
      items-center
      justify-between
      cursor-pointer
    " @click="openFilter = !openFilter"
    id="year-dropdown-container">
    <div class="capitalize  text-sm sm:text-base">
      {{ selectedYear ? selectedYear + '0' : content.yearDropdown }}
    </div>
    <div>
      <i class="fa fa-chevron-down transition-all duration-300" :class="{ 'rotate-180': openFilter }"></i>
    </div>
    <div class="
        max-h-0
        
        overflow-hidden
        min-w-[110px]
        transition-all
        duration-300
        absolute
        left-0
        top-[70px]
        z-[2]
        bg-primary
      " id="year-dropdown" :class="{ 'years-opened': openFilter }">
      <div @click="selectedYear = null" class="
          capitalize  text-sm sm:text-base
          px-4
          flex
          items-center
          h-12
          hover:bg-secondary
          transition-all
          duration-200
          cursor-pointer
        ">
        {{ content.yearDropdown }}
      </div>
      <div v-for="decade in decades" :key="decade">
        <div @click="selectedYear = decade" v-if="selectedYear != decade" class="
            capitalize  text-sm sm:text-base
            px-4
            flex
            items-center
            h-12
            hover:bg-secondary
            transition-all
            duration-200
            cursor-pointer
          ">
          {{ decade }}0
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  inject: ["content"],
  data() {
    return {
      openFilter: false,
      selectedYear: null,
      decades: ["197", "198", "199", "200", "201", "202"],
    };
  },
  watch: {
    selectedYear() {
      this.$emit("setYear", this.selectedYear);
    },
  },
  methods: {
    closeMenu(event) {
      if(!document.getElementById('year-dropdown-container'))return false;
      if (
        !document.getElementById("year-dropdown-container").contains(event.target) 
      ) {
        document.getElementById("year-dropdown").classList.remove("years-opened");
        this.openFilter = false;

        //the same code you've used to hide the menu
      }
    },
  },
  mounted() {
    window.addEventListener("click", this.closeMenu);

  }

};
</script>